import { render, staticRenderFns } from "./OsLoadingIndicator.vue?vue&type=template&id=0ed49f95&scoped=true"
import script from "./OsLoadingIndicator.vue?vue&type=script&lang=ts"
export * from "./OsLoadingIndicator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed49f95",
  null
  
)

export default component.exports